/* FamilyStore.io Option 6 "Family Market": product rails (scroller + quick add). Steward 2026-09-26.
   - <fs6-rail>: prev/next paging for the horizontal product track, button states, hides nav when nothing overflows.
   - form[data-fs6-add]: progressive enhancement of the card's real /cart/add form.
     POSTs via fetch, opens Sense's cart notification (or drawer) when present, publishes
     PUB_SUB_EVENTS.cartUpdate, and dispatches 'fs6:cart-updated' on document (bubbles to window)
     with detail { source, variantId, item, cart } where cart is a fresh /cart.js payload when available. */
(function () {
  if (window.__fs6RailsLoaded) return;
  window.__fs6RailsLoaded = true;

  var reduceMotion = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  if (!customElements.get('fs6-rail')) {
    customElements.define(
      'fs6-rail',
      class Fs6Rail extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-fs6-track]');
          if (!this.track) return;
          this.prev = this.querySelector('[data-fs6-prev]');
          this.next = this.querySelector('[data-fs6-next]');
          this.nav = this.querySelector('[data-fs6-nav]');
          this.frame = null;
          this.schedule = this.schedule || this.scheduleUpdate.bind(this);
          this.onPrev = this.onPrev || this.page.bind(this, -1);
          this.onNext = this.onNext || this.page.bind(this, 1);
          this.track.addEventListener('scroll', this.schedule, { passive: true });
          if (this.prev) this.prev.addEventListener('click', this.onPrev);
          if (this.next) this.next.addEventListener('click', this.onNext);
          if ('ResizeObserver' in window) {
            this.observer = new ResizeObserver(this.schedule);
            this.observer.observe(this.track);
          } else {
            window.addEventListener('resize', this.schedule);
          }
          this.update();
        }

        disconnectedCallback() {
          if (!this.track) return;
          this.track.removeEventListener('scroll', this.schedule);
          if (this.prev) this.prev.removeEventListener('click', this.onPrev);
          if (this.next) this.next.removeEventListener('click', this.onNext);
          if (this.observer) this.observer.disconnect();
          window.removeEventListener('resize', this.schedule);
        }

        scheduleUpdate() {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        }

        page(direction) {
          var button = direction < 0 ? this.prev : this.next;
          if (button && button.getAttribute('aria-disabled') === 'true') return;
          var track = this.track;
          var item = track.querySelector('.fs6-rail__item');
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          var step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
          var perView = Math.max(1, Math.floor((track.clientWidth + gap) / step));
          track.scrollBy({ left: direction * perView * step, behavior: reduceMotion() ? 'auto' : 'smooth' });
        }

        update() {
          var track = this.track;
          var max = track.scrollWidth - track.clientWidth;
          var overflow = max > 2;
          var x = Math.abs(track.scrollLeft);
          if (this.nav) this.nav.hidden = !overflow;
          if (this.prev) this.prev.setAttribute('aria-disabled', String(!overflow || x <= 2));
          if (this.next) this.next.setAttribute('aria-disabled', String(!overflow || x >= max - 2));
        }
      }
    );
  }

  /* ---------- quick add ---------- */
  function announce(form, message) {
    var scope = form.closest('fs6-rail') || document;
    var region = scope.querySelector('[data-fs6-status]');
    if (!region) return;
    region.textContent = '';
    setTimeout(function () {
      region.textContent = message;
    }, 50);
  }

  function showError(form, message) {
    var el = form.querySelector('[data-fs6-error]');
    if (!el) return;
    if (message) {
      el.textContent = message;
      el.hidden = false;
    } else {
      el.textContent = '';
      el.hidden = true;
    }
  }

  function refreshCartBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return Promise.resolve();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + '?sections=cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (json) {
        var html = json && json['cart-icon-bubble'];
        if (!html) return;
        var section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (section) bubble.innerHTML = section.innerHTML;
      })
      .catch(function () {});
  }

  function onAdded(form, button, label, title, variantId, data, cart, canRender) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fs6-rail', productVariantId: variantId, cartData: data });
      }
    } catch (e) {}

    var opened = false;
    if (canRender && data.sections) {
      try {
        cart.renderContents(data);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        opened = true;
      } catch (e) {
        opened = false;
      }
    }

    if (label) label.textContent = 'Added';
    button.classList.add('is-added');
    if (!opened) announce(form, 'Added ' + title + ' to your cart.');
    setTimeout(function () {
      button.classList.remove('is-added');
      if (label) label.textContent = 'Add';
    }, 2500);

    // One /cart.js read so listeners (header pill, cart progress) can paint without refetching.
    var cartJs = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    var cartRead = fetch(cartJs, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
    Promise.all([opened ? null : refreshCartBubble(), cartRead]).then(function (results) {
      var detail = { source: 'fs6-rail', variantId: Number(variantId), item: data };
      if (results[1]) detail.cart = results[1];
      document.dispatchEvent(new CustomEvent('fs6:cart-updated', { bubbles: true, detail: detail }));
    });
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-fs6-add')) return;
    if (!window.fetch || !window.FormData) return; // native POST to /cart/add
    evt.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    var label = button.querySelector('[data-fs6-label]');
    var title = button.getAttribute('data-fs6-title') || '';
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var canRender =
      !!cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function';

    var body = new FormData(form);
    var variantId = body.get('id');
    if (canRender) {
      try {
        body.append(
          'sections',
          cart.getSectionsToRender().map(function (s) {
            return s.id;
          })
        );
        body.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
      } catch (e) {
        canRender = false;
      }
    }

    showError(form, '');
    button.setAttribute('aria-busy', 'true');
    button.classList.remove('is-added');
    if (label) label.textContent = 'Adding…';

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var request = fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    }).then(function (response) {
      return response.json();
    });

    request.then(
      function (data) {
        button.removeAttribute('aria-busy');
        if (!data || data.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'fs6-rail',
              productVariantId: variantId,
              errors: data && (data.errors || data.description),
              message: data && data.message,
            });
          }
          var msg = (data && (data.description || data.message)) || 'This item could not be added to your cart.';
          showError(form, msg);
          announce(form, msg);
          if (label) label.textContent = 'Add';
          return;
        }
        onAdded(form, button, label, title, variantId, data, cart, canRender);
      },
      function () {
        // No usable JSON (network or unexpected response): fall back to a normal add-to-cart POST.
        button.removeAttribute('aria-busy');
        if (label) label.textContent = 'Add';
        HTMLFormElement.prototype.submit.call(form);
      }
    );
  });
})();
